<template>
    <div v-if="templates && !isLoading">
        <BmvTable
            :columns="tableColumns"
            :data="templates"
            :pagination="!!pagination"
            :total-results="pagination ? pagination.total : 0"
            :total-pages="pagination ? Math.ceil(pagination.last_page) : 0"
            :current-page="pagination ? pagination.current_page : 1"
            :per-page="config.per_page || 20"
            :sort-field="config.sort"
            :sort-direction="config.sortDirection"
            @sort="onSort"
            @page-change="onPageChange"
        >
            <!-- Form name -->
            <template #cell-form="{ row }">
                {{ row.form && row.form.name ? row.form.name : '—' }}
            </template>

            <!-- Template name -->
            <template #cell-name="{ row }">
                <span style="font-weight: 600; color: #0f172a;">{{ row.response_title || '—' }}</span>
            </template>

            <!-- Actions -->
            <template #cell-actions="{ row }">
                <div class="d-flex align-items-center" style="gap: 6px;">
                    <router-link
                        v-if="can('response-templates.update')"
                        :to="`/admin/templates/${row.id}/edit`"
                        class="tt-btn tt-btn--edit"
                        :title="$t('common.edit')"
                    >
                        <i class="fal fa-pen" style="color: #fff !important;"></i>
                    </router-link>
                    <button
                        v-if="can('response-templates.delete')"
                        @click.prevent="deleteTemplate(row.id)"
                        class="tt-btn tt-btn--delete"
                    >
                        <i class="fal fa-trash" style="color: #fff !important;"></i>
                    </button>
                </div>
            </template>
        </BmvTable>

        <DeleteTemplate ref="deleteTemplate" :template="selectedTemplate" />
    </div>
</template>

<script>
import BmvTable from '@/components/UI/BmvTable'
import DeleteTemplate from './DeleteTemplate'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'TabTemplates',
    components: {
        BmvTable,
        DeleteTemplate
    },
    props: ['isLoading'],
    data: function () {
        return {
            selectedTemplate: {},
            tableColumns: [
                { field: 'form', label: this.$t('template.tab.form'), sortable: true },
                { field: 'name', label: this.$t('template.tab.name'), sortable: true },
                { field: 'actions', label: this.$t('forms.actions'), width: '120px', align: 'center' }
            ]
        }
    },
    methods: {
        ...mapActions('admin', ['getTemplates']),
        can(permission) {
            return this.permissions.includes(permission)
        },
        deleteTemplate(id) {
            this.templates.forEach((template) => {
                if (template.id === id) this.selectedTemplate = template
            })
            this.$refs.deleteTemplate.trigger()
        },
        onSort({ field, direction }) {
            this.config.page = 1
            this.config.sort = field
            this.config.sortDirection = direction
            this.$emit('load-data')
        },
        onPageChange(page) {
            this.config.page = page
            this.$emit('load-data')
        }
    },
    computed: {
        ...mapState('admin', {
            templates: (state) => state.templates,
            config: (state) => state.templatesConfig,
            pagination: (state) => state.pagination
        }),
        permissions() {
            return this.$store.state.auth.permissions
                || JSON.parse(localStorage.getItem('permissions') || '[]')
        }
    },
    created() {
        this.$emit('load-data')
    }
}
</script>

<style scoped>
.tt-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s ease;
}

.tt-btn i {
    font-size: 0.78rem;
}

.tt-btn--edit {
    background: #f59e0b;
}

.tt-btn--edit:hover {
    background: #d97706;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(245, 158, 11, 0.3);
}

.tt-btn--delete {
    background: #ef4444;
}

.tt-btn--delete:hover {
    background: #dc2626;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(239, 68, 68, 0.3);
}
</style>
